import './import-csv-popin.component.ajscss';

import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { IHistoryDeprecatedService } from '@history/core/history-deprecated.service';
import { element, IComponentController, IComponentOptions, ILogService, isDefined } from 'angular';
import { i18n } from 'i18next';

import { DisplayDeprecatedComponent, ToastClass, ToastType } from '@contact/upgrade';

import templateUrl from './import-csv-popin.component.ajs.html';

class ImportCsvPopinCtrl extends DisplayDeprecatedComponent implements IComponentController {
  close: Function;
  dismiss: Function;
  resolve: Function;

  csrList: any[] = [];
  customerRepositoryName: string;

  // If file info div visible property
  isCsvFileInfoShowed = false;

  // The properties used in cng-csv-import (csv-import)
  csv = {
    content: null,
    accept: '.csv',
    header: true,
    headerVisible: false,
    separator: ';',
    separatorVisible: false,
    result: null,
    encoding: 'UTF-8',
    encodingVisible: false,
    uploadButtonLabel: this.$i18next.t('history:viewContacts.modalImportCsv.choose'),
  };

  csvFileContent =
    'civility;contactFirstName;contactLastName;contactPhone1;contactPhone2;contactPhone3;contactMail1;contactMail2;contactId;description;customerRepositoryName\n' +
    'Ms;test1-name;test1-lastname;111111111;111111;456789123;test1-email@test.com;;test1-id;test1-description;default\n' +
    'Mr;test2-name;test2-lastname;123456789;258963147;;;;test2-id;test2-description;default';

  modelImportCsvFile: any = {
    isFileInvalid: false,
    fileInvalidMessage: [],
    contactListToImport: [],
  };

  constructor(
    private readonly $log: ILogService,
    private readonly $i18next: i18n,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly historyDeprecatedService: IHistoryDeprecatedService
  ) {
    super();
  }

  $onInit(): void {
    // read the modal parameter, type of ModalParamContactHisto
    let param = this.resolve();
    if (isDefined(param)) {
      this.csrList = param.csrList;
      this.customerRepositoryName = param.customerRepositoryName;
    } else {
      this.$log.error('[HistoryImportCsvCtrl] missing compulsory modal parameter');
    }
  }

  closeImportCsv(value?) {
    this.$log.info('closeImportCsv');
    if (value) {
      this.close({ $value: value });
    } else {
      this.close();
    }
  }

  // Reset properties method
  clearImportCsvProperties() {
    this.modelImportCsvFile.isFileInvalid = false;
    this.modelImportCsvFile.contactListToImport = [];
    this.modelImportCsvFile.fileInvalidMessage = [];
  }

  showCsvFileInfo() {
    this.$log.info('closeImportCsv');
    this.isCsvFileInfoShowed = !this.isCsvFileInfoShowed;
  }

  downloadCSVFileExample() {
    if (this.isCsvFileInfoShowed) {
      let blob = new Blob([this.csvFileContent], { type: 'text/csv;' });
      let filename = 'contacts.csv';
      let docBody = element(document.body);
      let downloadLink = element('<a></a>');
      downloadLink.attr('href', window.URL.createObjectURL(blob));
      downloadLink.attr('target', '_self');
      downloadLink.attr('download', filename);
      docBody.append(downloadLink);
      downloadLink[0].click();
    }
  }

  // Callback function validates importable file and content
  validateCsvFile() {
    if (this.csv.result != null) {
      // Call validate format method
      this.validateCsvFileFormat();
      // If file is csv
      if (!this.modelImportCsvFile.isFileInvalid) {
        const objStr = JSON.stringify(this.csv.result);
        let obj: any = null;
        try {
          // Parse to json
          obj = JSON.parse(objStr);
        } catch (e) {
          // Close popup
          this.closeImportCsv();
          // Show error
          this.showError('Unable parse file to json');
        }
        // Iterate csv file rows
        for (let i = 0; i < obj.length; i++) {
          // Call validate fields method
          let invalidField = this.validateFields(obj[i].contactFirstName, obj[i].contactLastName, obj[i].assignedCsrId);
          // Check the response of validation
          if (invalidField == null || invalidField === '') {
            // if no error fill contactListToImport
            this.modelImportCsvFile.contactListToImport.push(this.validateAndConvertToClientFile(obj[i]));
          } else {
            // Manage error message
            // Put all invalid rows in message
            // Each invalidField corresponds to label in locale file
            let message = this.$i18next.t('history:viewContacts.modalImportCsv.message.invalidFile.' + invalidField);
            if (message != null && message !== '') {
              // Show error message getting from locale file
              this.modelImportCsvFile.fileInvalidMessage.push(message + ' : [' + i + ']');
            } else {
              // If there is not label in locale file show original error case
              this.modelImportCsvFile.fileInvalidMessage.push(invalidField + ' : [' + i + ']');
            }
          }
        }
        // Show error message in case of invalid format and empty file
        if (this.modelImportCsvFile.fileInvalidMessage.length > 0) {
          this.modelImportCsvFile.isFileInvalid = true;
        } else if (this.modelImportCsvFile.contactListToImport.length === 0) {
          this.modelImportCsvFile.fileInvalidMessage.push(this.$i18next.t('history:viewContacts.modalImportCsv.message.invalidFile.empty'));
          this.modelImportCsvFile.isFileInvalid = true;
        }
      }
    }
  }

  // Function validates file format
  private validateCsvFileFormat() {
    // Reset properties each time when choose a new file
    this.clearImportCsvProperties();
    // Get file
    const val = $(".cng-csv-import input[type='file']").val().toLowerCase();
    const regex = new RegExp('(.*?).(csv)$');
    // Check file format
    if (!regex.test(val)) {
      // Clear
      $(".cng-csv-import input[type='file']").val('');
      // Get error message for invalid file format
      this.modelImportCsvFile.fileInvalidMessage.push(
        this.$i18next.t('history:viewContacts.modalImportCsv.message.invalidFile.invalidFormat')
      );
      // Show message
      this.modelImportCsvFile.isFileInvalid = true;
    }
  }

  // Function validates fields
  private validateFields(firstname, lastname, assignedCsrId) {
    // If hasn't specified name
    if ((firstname == null || firstname === '') && (lastname == null || lastname === '')) {
      return 'noName';
    }
    // If assigned csr ids are wrong
    if (assignedCsrId != null && assignedCsrId !== '') {
      let assignedCsr;
      for (let i = 0; i < this.csrList.length; i++) {
        assignedCsr =
          this.csrList[i].firstname + ' ' + this.csrList[i].lastname === assignedCsrId || this.csrList[i].uuid === assignedCsrId;
        if (assignedCsr) {
          break;
        }
      }
      if (!assignedCsr) {
        return 'invalidAssignedId';
      }
    }
    return '';
  }

  // Function validates fields and convert
  validateAndConvertToClientFile(data) {
    let result: any = {
      firstname: data.contactFirstName || '',
      lastname: data.contactLastName || '',
      addresses: [],
      contactId: data.contactId || '',
      description: data.description || '',
      assignedCsrId: data.assignedCsrId || '',
      customerRepositoryName: this.customerRepositoryName,
      civility: data.civility,
    };

    if (this.isPhoneFormatOk(data.contactPhone1)) {
      result.addresses.push({ uri: data.contactPhone1, channel: 'PHONE_INCOMING' });
    }
    if (this.isPhoneFormatOk(data.contactPhone2)) {
      result.addresses.push({ uri: data.contactPhone2, channel: 'PHONE_INCOMING' });
    }
    if (this.isPhoneFormatOk(data.contactPhone3)) {
      result.addresses.push({ uri: data.contactPhone3, channel: 'PHONE_INCOMING' });
    }
    if (this.isMailFormatOk(data.contactMail1)) {
      result.addresses.push({ uri: data.contactMail1, channel: 'MAIL_INCOMING' });
    }
    if (this.isMailFormatOk(data.contactMail2)) {
      result.addresses.push({ uri: data.contactMail2, channel: 'MAIL_INCOMING' });
    }

    return result;
  }

  // Function validates phone format
  private isPhoneFormatOk(phoneNumber) {
    if (phoneNumber == null || phoneNumber === '') {
      return true;
    }
    const phoneNumberRegexp = /^[0-9]*$/;
    return phoneNumberRegexp.test(phoneNumber);
  }

  // Function validates mail format
  private isMailFormatOk(mail) {
    if (mail == null || mail === '') {
      return true;
    }
    const mailFormatRegexp = /^.+@.+$/;
    return mailFormatRegexp.test(mail);
  }

  // Import contacts process
  importCsvFile() {
    if (!this.modelImportCsvFile.isFileInvalid && this.modelImportCsvFile.contactListToImport.length > 0) {
      this.$log.info('importCsvFile');
      this.historyDeprecatedService.importContacts(this.modelImportCsvFile.contactListToImport).then(
        response => {
          this.contactImportProcessed(response);
        },
        error => {
          this.errorOccurred(error);
        }
      );
    }
  }

  // Import process success callback
  contactImportProcessed(e) {
    let count = 0;
    if (e.data.data != null && e.data.data !== '') {
      count = Number(e.data.data);
    }

    if (count > 0) {
      //  parseInt(e.data.data);
      let message_text =
        count === 1
          ? count + ' ' + this.$i18next.t('history:viewContacts.modalImportCsv.message.successfullyImported')
          : count + ' ' + this.$i18next.t('history:viewContacts.modalImportCsv.message.successfullyImportedMultiple');
      this.toastDeprecatedService.add(ToastType.NOTIFICATION, message_text, ToastClass.HISTORY, 3000);
      // Close popup
      this.closeImportCsv('reload');
    } else {
      this.errorOccurred(e);
    }
  }

  // Error handling
  errorOccurred(e) {
    this.dismiss({ $value: e });
  }

  // Show error message
  showError(message: string) {
    this.toastDeprecatedService.alert(message);
  }
}

export class ImportCsvPopin implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    // from ui-bootstrap modal
    close: '&',
    dismiss: '&',
    resolve: '&',
  };
  controller = ['$log', '$i18next', 'toastDeprecatedService', 'historyDeprecatedService', ImportCsvPopinCtrl];
}

export default 'historyImportCsvView';
